import request from '@/utils/request';

// 设备报表
export const getFaultTypeStatistics = (params: any) =>
  request({
    url: 'StatisticsFaultType/faultType',
    method: 'get',
    params
  });

// 导出excel 设备列表
export const exportFaultTypeStatistics = (params: any) =>
  request({
    url: 'StatisticsFaultType/export',
    method: 'get',
    params
  });
